/**
 * Whether the boot reports where its time went.
 *
 * Always in development. In a built bundle, only when the page is opened
 * with `?boot` in its query - so a deployed fab can be measured on the
 * machine that is slow, in the tab that is slow, without a dev server in the
 * way. The marks themselves cost nothing; the console lines are the point.
 */
export const BOOT_TIMING: boolean =
  import.meta.env.DEV || (typeof location !== 'undefined' && /[?&]boot\b/.test(location.search))
